export default __webpack_public_path__ + "static/media/img-celcom-logo.f04b16ff.svg";